module.exports = __webpack_public_path__ + "img/Logo_azul_recuperi.487bd96b.png";